import DOMPurify from 'dompurify';

function cleanHtml(html?: string) {
    return DOMPurify.sanitize(html || '');
}

function slugify(text: string): string {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[\s-]+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/^_+|_+$/g, '');
}

export { cleanHtml, slugify };
